import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/pages/tasks/index';
import {loadTasks} from '../../../reducers/tasks/actions';
import {loadBoxes} from '../../../reducers/lootbox/actions'; 
import PageContainer from '../page-container';
import Components from '../../components';
import tippy from 'tippy.js';

import Diamond from './diamond';
import Daily from './daily';
import Weekly from './weekly';
import General from './general';

import Shop from './shop';
import FAQ from './faq';

import Triggers from '../../../lib/triggers';

export default () => {
    const {loaded, user} = useSelector(Selector),
          dispatch = useDispatch(),
          location = useLocation(),
          searchParams = new URLSearchParams(window.location.search);

    const scrollToFacebookTasks = () => {
        setTimeout(() => {
            window.scrollTo(0, document.querySelectorAll('.tasks-title')[1].offsetTop - 100);
        }, 200);
    }

    useEffect(() => {
        if(!loaded) {
            dispatch(loadTasks());
            dispatch(loadBoxes()); 
        } else {
            Components.Loader.closePage();
            Components.Loader.close(); 

            if(searchParams.get('redirect_from') === 'facebook_modal')
                scrollToFacebookTasks();
        }
    }, [loaded]);

    useEffect(() => {
        tippy('#weekly_tooltip', {
            placement: "top",
            animation: 'fade',
            theme: 'translucent',
            arrow: true, 
            content: '<b>Weekly Streak</b> — Don’t break the chain! Complete daily tasks all week to claim the biggest reward.',
            allowHTML: true
        });
    });

    useEffect(() => {
        Triggers.page_view({
            page: "tasks"
        });
    }, [location]);


    
    return (
        <PageContainer>
            <Components.Loader.Page />
            <div className="tasks-page">
                <Components.Winners />

                {loaded ? (
                    <div className="tasks-container">
                        <div className="tasks-top">
                            <div className="layer dots">
                                {/* Lights */}
                                <div className="light">
                                    <div className="circle"></div>
                                    <div className="dot"></div>
                                </div>
                                <div className="light">
                                    <div className="circle"></div>
                                    <div className="dot"></div>
                                </div>
                                <div className="light">
                                    <div className="circle"></div>
                                    <div className="dot"></div>
                                </div>
                            </div>
                            <div className="layer diamonds">
                                <div className="diamond"></div>
                                <div className="diamond"></div>
                                <div className="diamond"></div>
                            </div>
                            <div className="layer mascot">
                                <div className="girl"></div>
                            </div>
                            <div className="layer content">
                                <div className="title">BONUS<br/>ZONE</div>
                                <div className="descriptions">Complete the tasks and earn diamonds. Exchange diamonds for prizes and play on Lucksy</div>
                                <div className="balance">
                                    <span>Balance</span>
                                    <div className="bal">
                                        <Diamond />
                                        {user.diamonds}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="tasks-body">
                            <div className="left">
                                {(user.phone.status !== "confirmed" || user.email.status !== "confirmed") ? (
                                    <div className="tasks-group">
                                        <div className="tasks-title">
                                            General Tasks
                                        </div>
                                        <div className="tasks-list">
                                            <General.Phone />
                                            <General.Email /> 
                                        </div>
                                    </div>
                                ) : <></>}
                                <div className="tasks-group">
                                    <div className="tasks-title">
                                        Daily Tasks
                                    </div>
                                    <div className="tasks-list">
                                        <Daily.Deposit />
                                        <Daily.CryptoDeposit /> 
                                    </div>
                                    <div className="tasks-list">
                                        <Daily.TrippleDeposit /> 
                                        <Daily.VipDeposit />
                                    </div>
                                    <div className="tasks-list">
                                        <Daily.Games /> 
                                    </div>
                                </div>

                                <div className="tasks-group">
                                    <div className="tasks-title">
                                        Social Tasks
                                    </div>
                                    <div className="tasks-list">
                                        <Daily.Facebook />
                                        <Daily.FacebookStory />
                                    </div>
                                </div>
                            </div>
                            <div className="line"></div>
                            <div className="right">
                                <div className="tasks-group">
                                    <div className="tasks-title">
                                        Weekly Streaks
                                        <span id="weekly_tooltip">
                                            <svg width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.76935 6.89831C3.599 6.95832 3.05956 7.10121 2.8135 6.97404C2.77955 6.95618 2.7509 6.93111 2.73002 6.90099C2.70914 6.87088 2.69665 6.83661 2.69362 6.80115C2.61634 6.35536 2.98385 5.32518 3.18259 4.77222C3.24884 4.5879 3.29616 4.45359 3.31508 4.37215C3.45862 3.77061 3.38764 3.31053 3.10372 3.00476C2.76208 2.63684 2.15608 2.56525 1.65891 2.63184C1.15338 2.69287 0.659355 2.81593 0.190441 2.99762C0.168659 3.00717 0.149626 3.02118 0.134844 3.03853C0.120063 3.05589 0.109937 3.07613 0.105266 3.09764L0.0027414 3.542C-0.00280314 3.56699 -0.000903996 3.59287 0.00824359 3.61697C0.0173912 3.64108 0.0334575 3.66255 0.0547925 3.67917C0.0763936 3.69543 0.102276 3.70634 0.129917 3.71085C0.157559 3.71536 0.186018 3.7133 0.212523 3.70489C0.400222 3.64202 0.98698 3.50056 1.19676 3.67488C1.31506 3.77347 1.28194 3.98208 1.23462 4.13782C1.18572 4.30071 1.12736 4.47645 1.06742 4.66077C0.679405 5.8567 0.23776 7.21266 0.938084 7.63559C1.26942 7.86476 1.67272 7.99237 2.08952 7.99994C2.49962 7.99994 3.00593 7.88278 3.73465 7.61558C3.75661 7.60785 3.77637 7.59574 3.79248 7.58016C3.80858 7.56458 3.82062 7.54593 3.82771 7.52557L3.97755 7.07263C3.98604 7.04681 3.98641 7.01935 3.9786 6.99335C3.9708 6.96735 3.95514 6.94384 3.93339 6.92546C3.91163 6.90742 3.8847 6.8953 3.85568 6.89049C3.82666 6.88569 3.79674 6.8884 3.76935 6.89831ZM2.85766 -6.10352e-05C2.63203 8.02692e-05 2.4115 0.060811 2.22396 0.174456C2.03641 0.288101 1.89026 0.449559 1.80399 0.638424C1.71771 0.827289 1.69518 1.03508 1.73924 1.23555C1.7833 1.43601 1.89197 1.62014 2.05152 1.76467C2.21107 1.9092 2.41433 2.00764 2.63563 2.04755C2.85692 2.08746 3.08631 2.06705 3.2948 1.9889C3.50329 1.91074 3.68153 1.77836 3.80698 1.60846C3.93244 1.43857 3.99948 1.23881 3.99963 1.03441C3.99955 0.760074 3.87921 0.496996 3.66507 0.303012C3.45092 0.109028 3.16051 1.47167e-05 2.85766 -6.10352e-05Z" fill="white"/>
                                            </svg>
                                        </span>
                                    </div>

                                    <div className="tasks-list">
                                        <Weekly.Online />
                                        <Weekly.Deposits />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="shop-lore">You will soon be able to spend diamonds here.</div>  */}
                        <Shop /> 

                        <FAQ /> 
                    </div>
                ) : <></>}
                <Components.Footer />
            </div>
        </PageContainer>
    )
}